import { isEmpty } from 'lodash';
import studentProfile from '../../../apis/studentProfile';

export const fetchAllSearchStudentFeeEntryReportPages = async (params: any) => {
  const perPage = 400;
  let pageNo = 1;
  let allData: any[] = [];
  while (true) {
    const response = await studentProfile.fetchStudentReportApi(
      params,
      pageNo,
      perPage
    );
    const pageData = response || [];
    if (isEmpty(pageData)) break;
    allData = allData.concat(pageData);
    pageNo++;
  }
  return allData;
};
